import { useConditionValuesFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionValuesWarning = () => {
  const fieldPath = useConditionValuesFieldPath();
  const { getHasWarningFromFieldPath } = useQueryErrorStateContext();
  const warningFromFieldPath = getHasWarningFromFieldPath(fieldPath);

  return warningFromFieldPath;
};
